import { DataGrid } from '@material-ui/data-grid';
import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      height: 500,
      marginTop: theme.spacing(1),
    },
    submit: props => ({
      margin: theme.spacing(3, 0, 2),
      background: props.palette.gradient.default
    }),
  }));

export default function BasicEditingGrid(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const loadedRows = props.props.data[0] ? props.props.data : defaultRows;
  console.log(loadedRows);
  const handleNext = props.props.function? props.props.function : "";
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [rows, setRows] = React.useState(loadedRows);


  const handleEditRowModelChange = React.useCallback((params) => {
    setEditRowsModel(params.model);
  }, []);

  const handleEditCellChangeCommitted = React.useCallback(
    ({ id, field, props }) => {
        const data = props; // Fix eslint value is missing in prop-types for JS files
        const someValue = data.value.toString();
        var updatedRows = [];
        switch(field) {
            case "name": 
                updatedRows = rows.map((row) => {
                    if (row.id === id) {
                        return { ...row, name: someValue};
                    }
                    return row;
                });
                setRows(updatedRows);
                console.log(rows);
                return;
            case "phoneNumber":
                updatedRows = rows.map((row) => {
                    if (row.id === id) {
                        return { ...row, phoneNumber: someValue};
                    }
                    return row;
                });
                setRows(updatedRows);
                console.log(rows);
                return;
            case "position": 
                updatedRows = rows.map((row) => {
                    if (row.id === id) {
                        return { ...row, position: someValue};
                    }
                    return row;
                });
                setRows(updatedRows);
                console.log(rows);
                return;
        }
      
    },
    [rows],
  );

  const populateValues = () => {
    const fs = firebase.firestore()
    var user = firebase.auth().currentUser;
    fs.collection("users").doc(user.email).get()
    .then((snapshot) => {
        if (snapshot.exists) { 
        const dat  = snapshot.data()
        setRows(dat.Roster.data ? dat.Roster.data : defaultRows)
        } else {
        console.log("No data available");
        }
    }).catch((error) => {
        console.log("error")
    })
}


  const handleSignUp = useCallback(
    async (event, rows) => {
      event.preventDefault();
        console.log(rows);
        console.log("going home");
        try {
       
            var user = firebase.auth().currentUser;
            const dateObj = new Date();
            const options = {year: 'numeric', month: 'long', day: 'numeric'};
            const date = dateObj.toLocaleDateString(undefined, options)
            const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

    
            db.collection("users").doc(user.email).update({
              Roster: {
                data: rows,
                completed: true
              },
            LastUpdated: (date + " " + time)
            });
            
            handleNext();
          } catch (error) {
            alert(error);
        }
    },
    [history]
  );
    return (
    <ThemeProvider theme={currentTheme}>
        <Container component="main" maxWidth="lg" >
          <CssBaseline />
          <div className={classes.paper}>
          <Typography component="h1" variant="h3">
            Roster
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
        Please list all dancers, instrumentalists, and managers. You must have no fewer than eight dancers and no more than 16 dancers. Instrumentalists, managers, and alternates do not count as dancers but must be included on this roster. You may have no more than 20 total members on the roster.
        </Typography>
            <form className={classes.form} onSubmit={(e) => handleSignUp(e, rows)}>
                <DataGrid 
                rows={rows} 
                columns={columns} 
                editRowsModel={editRowsModel}
                onEditRowModelChange={handleEditRowModelChange}
                onEditCellChangeCommitted={handleEditCellChangeCommitted}/>
            <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            >
            Submit
          </Button>
          </form>
      </div>
      <Box mt={8}>
      
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </Box>
    </Container>
    </ThemeProvider>
  );
}

const columns = [
  { field: 'id', headerName: ' ', width: 180, editable: false, type: 'number' },
  { field: 'name', headerName: 'Name', width: 180, editable: true },
  { field: 'phoneNumber', headerName: 'Phone Number', width: 180, editable: true },
  {
    field: 'position',
    headerName: 'Position',
    width: 180,
    editable: true,
  },

];

var foo = [];
for (var i = 1; i <= 20; i++) {
    foo.push({
            id: i,
            name: "",
            phoneNumber: "",
            position: "",
    })
 }

const defaultRows = foo;